const ENV_JS = '/env.js';
const RELOADED_FOR_KEY = 'platform-upgrader:reloaded-for';

/**
 * Whether the frontend already serves ``version``. During an upgrade the upgrader
 * can report the new version before the frontend pods roll; reloading then would
 * load the old assets again.
 */
export async function frontendServes(version) {
    try {
        const response = await fetch(`${ENV_JS}?v=${encodeURIComponent(version)}&t=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) return false;
        return (await response.text()).includes(`APP_VERSION: "${version}"`);
    } catch {
        return false;
    }
}

/**
 * The version this tab last reloaded itself for. A page that reloaded and still
 * runs an older frontend must not reload again, or it would loop.
 */
export function reloadedFor() {
    try {
        return window.sessionStorage.getItem(RELOADED_FOR_KEY);
    } catch {
        return null;
    }
}

export function rememberReloadFor(version) {
    try {
        window.sessionStorage.setItem(RELOADED_FOR_KEY, version);
    } catch {
        // Without storage the guard is lost; the settle delay still spaces reloads out.
    }
}
